// extracted by mini-css-extract-plugin
module.exports = {"landingPageContainer":"LandingPage_landingPageContainer__24Ryq","img":"LandingPage_img__3GVdA"};